import React from "react";
import arrowRight from "../../../assets/arrow-right-icon-white.svg";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { closeItemUnderReviewModal } from "../../../store/actions/header";
import { useTranslation } from "react-i18next";

const ActionButtons = () => {
  const navigate: any = useNavigate();
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const handleGoHome = () => {
    navigate("/");
    dispatch(closeItemUnderReviewModal());
  };

  const handleApprovalRequest = () => {
    navigate("/approval-request");
    dispatch(closeItemUnderReviewModal());
  };

  return (
    <div className="flex items-center gap-2">
      <button
        className="flex items-end justify-center gap-2 text-base p-3 bg-main text-white rounded-3xl w-3/5"
        type="button"
        onClick={handleApprovalRequest}
      >
        {t('add_edit_product_30')}
        <img src={arrowRight} alt="msg" />
      </button>
      <button
        className="flex items-end justify-center gap-2 font-medium p-3 bg-grey-EF text-main rounded-3xl flex-1"
        type="button"
        onClick={handleGoHome}
      >
        {t('add_edit_product_31')}
      </button>
    </div>
  );
};

export default ActionButtons;
